<template>
  <Popover class="relative">
    <PopoverButton v-slot="{ close }">
      <div ref="anchor">
        <slot name="button" :close="close" />
      </div>
    </PopoverButton>

    <PopoverPanel v-slot="{ close }">
      <div ref="floating" class="z-999" :style="floatingStyles">
        <slot :close="close" />
      </div>
    </PopoverPanel>
  </Popover>
</template>
<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { autoUpdate, flip, shift, useFloating } from '@floating-ui/vue';
import { ref } from 'vue';

const anchor = ref(null);
const floating = ref(null);
const { floatingStyles } = useFloating(anchor, floating, {
  whileElementsMounted: autoUpdate,
  middleware: [shift(), flip()],
  strategy: 'fixed',
});
</script>
